import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseManagementFeeEmpty.module.scss'

const cx = className.bind(style)

const MyhouseManagementFeeEmpty: React.FC = () => {
  return <p className={cx('article')}>해당 면적에는 관리비 정보가 없습니다.</p>
}

export default MyhouseManagementFeeEmpty
